export var InvalidSubscription;
(function (InvalidSubscription) {
    InvalidSubscription[InvalidSubscription["MISSING_PAYMENT_OVER_7_DAYS"] = 0] = "MISSING_PAYMENT_OVER_7_DAYS";
    InvalidSubscription[InvalidSubscription["CANCELLED"] = 1] = "CANCELLED";
    InvalidSubscription[InvalidSubscription["FREE_TRIAL_EXPIRED"] = 2] = "FREE_TRIAL_EXPIRED";
    InvalidSubscription[InvalidSubscription["FREE_TRIAL_MAX_USERS"] = 3] = "FREE_TRIAL_MAX_USERS";
})(InvalidSubscription || (InvalidSubscription = {}));
export var ValidSubscription;
(function (ValidSubscription) {
    ValidSubscription[ValidSubscription["MISSING_PAYMENT_UNDER_7_DAYS"] = 0] = "MISSING_PAYMENT_UNDER_7_DAYS";
    ValidSubscription[ValidSubscription["ACTIVE"] = 1] = "ACTIVE";
    ValidSubscription[ValidSubscription["FREE_TRIAL"] = 2] = "FREE_TRIAL";
})(ValidSubscription || (ValidSubscription = {}));
